module.exports = __webpack_public_path__ + "static/media/file-share-alt.74cb9d3d.svg";